module.exports = __webpack_public_path__ + "media/images/test_module_default-02a84958.jpg";